export const YoutubeWhite = ({ width = '20', height = '20' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3851_23444)">
        <path
          d="M19.5575 4.94083L19.5825 5.10417C19.3408 4.24667 18.6883 3.585 17.8592 3.34417L17.8417 3.34C16.2825 2.91667 10.0083 2.91667 10.0083 2.91667C10.0083 2.91667 3.75 2.90833 2.175 3.34C1.33 3.585 0.676668 4.24667 0.439168 5.08667L0.435001 5.10417C-0.147499 8.14667 -0.151666 11.8025 0.460834 15.06L0.435001 14.895C0.676668 15.7525 1.32917 16.4142 2.15833 16.655L2.17583 16.6592C3.73333 17.0833 10.0092 17.0833 10.0092 17.0833C10.0092 17.0833 16.2667 17.0833 17.8425 16.6592C18.6883 16.4142 19.3417 15.7525 19.5792 14.9125L19.5833 14.895C19.8483 13.48 20 11.8517 20 10.1883C20 10.1275 20 10.0658 19.9992 10.0042C20 9.9475 20 9.88 20 9.8125C20 8.14833 19.8483 6.52 19.5575 4.94083ZM8.00667 13.0425V6.965L13.2283 10.0083L8.00667 13.0425Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3851_23444">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
